import {Component, Input} from '@angular/core';
import {
  CompanyResponse,
  UserEntityRelationWithoutUserDataResponse,
  UserResponse
} from '../../../../@shared/models/response.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from '../../../../@core/services/user.service';
import {CompanyService} from '../../../../@shared/services/company.service';
import {forkJoin, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Router} from '@angular/router';
import {CreateOrganisation} from './components/create-organisation/create-organisation';
import {StorageService} from '../../../../@core/services/storage.service';

interface UserCompany {
  company: CompanyResponse;
  role_id: number;
  role_name: string;
}

@Component({
  selector: 'app-user-profile-organisations',
  standalone: false,
  templateUrl: './user-profile-organisations.html',
  styleUrl: './user-profile-organisations.css'
})
export class UserProfileOrganisations {
  @Input() user: UserResponse
  userCompanies: UserCompany[] = []
  loading: boolean = false

  constructor(
    private modal: NgbModal,
    private userService: UserService,
    private companyService: CompanyService,
    private router: Router,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.loadUserOrganisations()
  }

  loadUserOrganisations() {
    this.loading = true

    // Get user's entity relations (companies)
    this.userService.getUserEntityRelation().subscribe({
      next: (entities) => {
        if (entities && entities.length > 0) {
          // Create an array of observables to fetch company details
          const companyRequests = entities.map(entity =>
            this.companyService.getCompanyById({company_id: entity.entity_id}).pipe(
              map(company => ({
                company: company,
                role_id: entity.role_id,
                role_name: entity.role_name
              })),
              catchError(() => of(null))
            )
          )

          // Execute all requests in parallel
          forkJoin(companyRequests).subscribe({
            next: (companies) => {
              this.userCompanies = companies.filter(c => c !== null) as UserCompany[]
              this.loading = false
            },
            error: () => {
              this.loading = false
            }
          })
        } else {
          this.userCompanies = []
          this.loading = false
        }
      },
      error: () => {
        this.loading = false
      }
    })
  }

  createNewOrganisation() {
    const modalRef = this.modal.open(CreateOrganisation, {size: 'lg', centered: true})

    modalRef.result.then((result) => {
      if (result) {
        // Reload organisations after successful creation
        this.loadUserOrganisations()
      }
    }).catch(() => {
      // Modal dismissed
    })
  }

  editOrganisation(company: CompanyResponse) {
    // TODO: Open edit organisation modal or navigate to company profile
    console.log('Edit organisation:', company.company_id)
    // Navigate to company profile page
    this.router.navigate(['/company-profile'], {
      queryParams: { companyId: company.company_id }
    })
  }

  viewOrganisation(company: CompanyResponse) {
    this.switchCompany(company)
    // Navigate to company profile page
    this.router.navigate(['/company-profile'], {
      queryParams: { companyId: company.company_id }
    })
  }

  getRoleBadgeClass(roleId: number): string {
    // 0 = Owner, 1 = Admin, 2 = Member, etc.
    switch (roleId) {
      case 0:
        return 'badge-primary'
      case 1:
        return 'badge-success'
      default:
        return 'badge-secondary'
    }
  }

  switchCompany(company: CompanyResponse) {
    const companyId = company.company_id;
    const payload: UserEntityRelationWithoutUserDataResponse = {
      entity_id: company!.company_id,
      entity_name: company!.company_name,
      role_id: 1,
      role_name: 'Admin',
      created_at: company!.created_at,
      updated_at: company!.updated_at,
      deleted_at: company!.deleted_at,
    }
    this.storageService.saveSelectedCompany(payload);
    console.log("display toast")
    // this.toastService.success("Success", 'test');
    // window.location.reload();
  }
}
